import React from 'react'
import { ISpell } from '../../../../api/types/spell'
import { useInvalidatingMutation } from '../../../../hooks/useInvalidatingMutation'
import { AxiosResponse } from 'axios'
import { mutationDeleteSpell } from '../../../../api/mutations'
import { spellsQueryKey } from '../../../../api/queries'
import {
  Box,
  Card,
  CardActions,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material'
import { DeleteIconButton } from '../../../../components/DeleteIconButton/DeleteIconButton'
import { EditIconButton } from '../../../../components/EditIconButton/EditIconButton'
import { useAuth } from '../../../../context/Auth'
import { SpellFormModal } from '../SpellFormModal/SpellFormModal'
import { Effect } from '../../../../components/Effect/Effect'

interface Props {
  spell: ISpell
}

export const Spell: React.FC<Props> = ({ spell }) => {
  const auth = useAuth()
  const { mutate: handleDeleteSpell, isLoading: isMutating } = useInvalidatingMutation<
    AxiosResponse,
    number
  >((id: number) => mutationDeleteSpell(id), [spellsQueryKey()])

  return (
    <>
      <Card
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ maxWidth: '400px' }}>
          <CardContent>
            <Typography variant="h5" component="div">
              {spell.name}
            </Typography>

            <Typography variant="overline">
              {spell.school}, krąg {spell.circle}
            </Typography>

            <Typography display="block" variant="caption" color="text.secondary" gutterBottom>
              {spell.target}
            </Typography>

            <Typography color="text.secondary" align={'justify'} gutterBottom>
              {spell.description}
            </Typography>

            <List sx={{ padding: '0px', margin: '0px' }}>
              {spell.duration_turns && (
                <ListItem sx={{ padding: '0px' }}>
                  <ListItemText primary={'Czas trwania (tury)'} />
                  <span>{spell.duration_turns}</span>
                </ListItem>
              )}
              {spell.range && (
                <ListItem sx={{ padding: '0px' }}>
                  <ListItemText primary={'Zasięg'} />
                  <span>{spell.range}</span>
                </ListItem>
              )}
              {spell.component && (
                <ListItem sx={{ padding: '0px' }}>
                  <ListItemText primary={'Komponent'} />
                  <span>{spell.component}</span>
                </ListItem>
              )}
              {spell.mana && (
                <ListItem sx={{ padding: '0px' }}>
                  <ListItemText primary={'Punkty skupienia'} />
                  <span>{spell.mana}</span>
                </ListItem>
              )}

              {spell.action_points !== null && (
                <ListItem sx={{ padding: '0px' }}>
                  <ListItemText primary={'Punkty akcji'} />
                  <span>{spell.action_points}</span>
                </ListItem>
              )}
            </List>

            {spell?.effect && <Effect effect={spell.effect} />}
          </CardContent>
        </Box>
        {(auth?.gm || auth?.admin) && (
          <Box>
            <CardActions>
              <DeleteIconButton
                confirmationBody={
                  <div>
                    Usunąć czar <span className={'font-weight-bold'}>{spell.name}</span>?
                  </div>
                }
                isLoading={isMutating}
                onClick={() => handleDeleteSpell(spell.id)}
              />

              <SpellFormModal spell={spell} title={'Edytuj czar'}>
                {showModal => <EditIconButton onClick={showModal} />}
              </SpellFormModal>
            </CardActions>
          </Box>
        )}
      </Card>
    </>
  )
}
